import React from 'react'
import { Image, TouchableOpacity } from 'react-native'
import { DS } from '../../design-system'
import { Wrapper } from './PlayerStats'
import PlayPractice from './PlayPractice.png'
import { useStore } from '../../models'
import { events } from '../../models/analytics/analytics-events'
import { observer } from 'mobx-react-lite'
import { useRouter } from 'expo-router'

export const EmptyProfile = observer(() => {
  const router = useRouter()
  const {
    analytics: { setEvent },
    session: { user }
  } = useStore()
  const userId = user?._id.toString()
  const playPracticeGame = () => {
    setEvent(events.homescreen.practice_game, {
      userId
    })
    router.navigate('/game/new')
  }
  return (
    <>
      <Wrapper
        style={{
          alignItems: 'center',
          padding: DS.spacing[24],
          gap: DS.spacing[16],
          backgroundColor: DS.palette['Brand/Yellow']
        }}
      >
        <Image style={{ width: 64, height: 132 }} source={PlayPractice} />
        <DS.Text style={{ textAlign: 'center' }} variant="Heading 2/Regular">
          Get started by playing a practice game
        </DS.Text>
        <TouchableOpacity
          onPress={playPracticeGame}
          style={[
            {
              width: '100%',
              backgroundColor: DS.palette['Global/Black'],
              padding: DS.spacing[16],
              borderRadius: DS.spacing[48],
              borderWidth: 1
            }
          ]}
        >
          <DS.Text variant="Body Medium/Medium" style={{ textAlign: 'center' }} color="Global/White">
            Start Playing
          </DS.Text>
        </TouchableOpacity>
      </Wrapper>
    </>
  )
})
